import { Segment } from 'semantic-ui-react';

export default function Preview({ layout: L }) {
  return (
    <div className="preview">
      {L.pages.map((pg, pi) => (
        <Segment as="article" className="sheet" key={pi} aria-label={`Page ${pi + 1} of the report`}>
          {pi === 0 && (
            <header>
              <div className="band"><div className="t1">Settlement Report</div><div className="t2">As at {L.asAt}</div></div>
              <dl className="hdrblock">
                {L.headerLines.map((x, i) => {
                  if (x.k === 'gap') return <div key={i} className="hl gap" />;
                  if (x.k === 'text') return <div key={i} className="hl"><dd className="full">{x.value}</dd></div>;
                  return <div key={i} className="hl"><dt>{x.label || ''}</dt><dd>{x.value || ''}</dd></div>;
                })}
              </dl>
            </header>
          )}
          <table className="ptable">
            <caption className="visually-hidden">Report page {pi + 1}</caption>
            <thead>
              <tr><th scope="col" className="lab">Year</th><th scope="col" colSpan={L.heads.length} className="yr">{L.year}</th></tr>
              <tr><th scope="col" className="lab">{L.partial ? 'Period' : 'Month'}</th>{L.heads.map((x, i) => <th scope="col" key={i}>{x}</th>)}</tr>
            </thead>
            <tbody>
              {pg.rows.map((r, ri) => {
                if (r.k === 'blank') return <tr key={ri} className="spacer" aria-hidden="true"><td colSpan={L.heads.length + 1} /></tr>;
                if (r.k === 'section') return <tr key={ri} className="sec"><th scope="colgroup" colSpan={L.heads.length + 1}>{r.title}</th></tr>;
                if (r.k === 'sub') return <tr key={ri} className="subh"><th scope="colgroup" colSpan={L.heads.length + 1}>{r.title}</th></tr>;
                if (r.k === 'kv') return <tr key={ri}><th scope="row" className="lab b">{r.label}</th><td colSpan={L.heads.length} className="kvv">{r.value}</td></tr>;
                return (
                  <tr key={ri}>
                    <th scope="row" className={`lab${r.bold ? ' b' : ''}`}>{r.label}</th>
                    {r.cells.map((c, i) => <td key={i} className={r.center ? 'ctr' : 'num'}>{c.t}</td>)}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Segment>
      ))}
    </div>
  );
}
